import { faShareNodes } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { scrollToSection } from '../../../../common/utilities';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const CASE_REFERRAL_SECTION_ID = 'case-referral';

const Referral = () => {
  const iconLinkContainerClasses = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;
  const linkClass = `${styles.LinkRight} ${styles.NotesLink}`;
  const iconClass = styles.Icon;

  return (
    <NavLink
      dataLinkId={CASE_REFERRAL_SECTION_ID}
      icon={faShareNodes}
      iconClassName={iconClass}
      iconContainerClassName={iconLinkContainerClasses}
      textClassName={linkClass}
      copy="Referral"
      onClick={scrollToSection}
    />
  );
};

export default Referral;
export { CASE_REFERRAL_SECTION_ID };
